import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navbar"
export default class extends Controller {
  static targets = ["background", "mobileMenu", "menuButton"]

  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll)
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    const scrollY = window.scrollY
    if (this.hasBackgroundTarget) {
      if (scrollY > 50) {
        this.backgroundTarget.classList.add("bg-[#0a0a0a]/95")
        this.backgroundTarget.classList.remove("bg-[#0a0a0a]/80")
      } else {
        this.backgroundTarget.classList.remove("bg-[#0a0a0a]/95")
        this.backgroundTarget.classList.add("bg-[#0a0a0a]/80")
      }
    }
  }

  toggleMobile() {
    if (this.hasMobileMenuTarget) {
      this.mobileMenuTarget.classList.toggle("hidden")
    }
  }
}
